// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Settings.css — Page-scoped styles for src/pages/Settings.jsx (light redesign).
 * Consumes redesign.css tokens/primitives; never redefines them.
 * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px
 */

/* ─── Page shell ──────────────────────────────────────────────────────────── */
.settings-page {
  max-width: 100%;
}

/* ─── Message banner (replaces legacy .message-banner styling) ────────────── */
.rd-message-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--bg-surface);
  color: var(--ink);
  font-size: 14px;
  box-shadow: var(--sh-sm);
  margin-bottom: 20px;
}
.rd-message-banner.success {
  background: var(--ok-soft);
  border-color: var(--ok-soft);
  color: var(--ok);
}
.rd-message-banner.error {
  background: var(--err-soft);
  border-color: var(--err-soft);
  color: var(--err);
}
.rd-message-banner.info {
  background: var(--info-soft);
  border-color: var(--info-soft);
  color: var(--info);
}
.rd-message-banner span {
  flex: 1 1;
  min-width: 0;
}
.rd-message-close {
  background: transparent;
  border: none;
  color: inherit;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.7;
  padding: 0 4px;
}
.rd-message-close:hover {
  opacity: 1;
}

/* ─── Two-column layout: left rail + right content ────────────────────────── */
.settings-layout {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 28px;
  align-items: start;
}

/* ── Left vertical tab rail ── */
.settings-rail {
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: sticky;
  top: 16px;
}
/* Category grouping — a small uppercase heading above each cluster of items. */
.settings-rail-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.settings-rail-group + .settings-rail-group {
  margin-top: 14px;
}
.settings-rail-heading {
  padding: 0 12px 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink-muted);
}
.settings-rail-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  border: none;
  border-radius: var(--r-sm);
  background: transparent;
  color: var(--ink-secondary);
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
  font-family: var(--iv-sans);
}
.settings-rail-item svg {
  flex-shrink: 0;
  color: var(--ink-muted);
}
.settings-rail-item:hover {
  background: var(--bg-inset);
  color: var(--ink);
}
.settings-rail-item.active {
  background: var(--bg-inset);
  color: var(--ink);
  font-weight: 600;
}
.settings-rail-item.active svg {
  color: var(--ink);
}

/* ── Right content column ── */
.settings-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.settings-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ─── Card head (icon tile + title/sub) ───────────────────────────────────── */
.settings-card-head {
  align-items: flex-start;
  justify-content: flex-start;
}
.rd-card-sub {
  font-size: 13px;
  color: var(--ink-secondary);
  margin-top: 2px;
}

/* ─── Form layout inside cards ────────────────────────────────────────────── */
.settings-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.rd-grid-2col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}
.settings-form-actions {
  display: flex;
  justify-content: flex-end;
}

/* Error-state field (pairs with .rd-input / .rd-textarea): red border and a
   faint red fill, as on the invoice form's "Customer name is required". */
.rd-input-error,
.rd-input-error:focus {
  border-color: var(--err);
  background: rgba(220, 38, 38, 0.035);
  box-shadow: 0 0 0 3px var(--err-soft);
}

/* The message just below the field, in red. Spacing comes from .rd-field's
   gap. */
.rd-error {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
}

.input-disabled {
  background: var(--bg-inset);
  color: var(--ink-muted);
  cursor: not-allowed;
}

/* ─── Logo upload ─────────────────────────────────────────────────────────── */
.logo-upload {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.logo-preview {
  width: 56px;
  height: 56px;
  border-radius: var(--r-md);
  background: var(--accent-soft);
  color: var(--accent-ink);
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 16px;
  overflow: hidden;
  flex-shrink: 0;
}
.logo-remove {
  color: var(--err);
}

/* The hint doubles as the staged-state indicator: while a file is selected but
   not yet uploaded it has to read as a pending action, not as help text, or the
   preview looks like a completed upload. */
.rd-hint.logo-staged {
  color: var(--warn-ink, #b9760a);
  font-weight: 600;
}

/* A dashed ring around the preview, for the same reason — it marks the image as
   not yet committed without needing a second line of copy. */
.logo-upload:has(.logo-staged) .logo-preview {
  outline: 2px dashed var(--warn, #f5a524);
  outline-offset: 2px;
}

/* ─── Wallet address row ──────────────────────────────────────────────────── */
.wallet-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.wallet-input-row input {
  flex: 1 1;
  min-width: 0;
}
.settings-section .icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: var(--r-sm);
  border: 1px solid var(--line-strong);
  background: var(--bg-surface);
  color: var(--ink-secondary);
  cursor: pointer;
  box-shadow: var(--sh-sm);
}
.settings-section .icon-btn:hover:not(:disabled) {
  background: var(--bg-inset);
}
.settings-section .icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ─── KYB status row ──────────────────────────────────────────────────────── */
.settings-kyb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 18px;
  border-top: 1px solid var(--line);
}
.settings-kyb-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
}

/* ─── Notes (info / warning callouts) ─────────────────────────────────────── */
.settings-note {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--bg-subtle);
}
.settings-note svg {
  flex-shrink: 0;
  margin-top: 1px;
}
.settings-note strong {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 2px;
}
.settings-note p {
  font-size: 13px;
  color: var(--ink-secondary);
  margin: 0;
}
.settings-note.info {
  background: var(--info-soft);
  border-color: var(--info-soft);
}
.settings-note.info svg {
  color: var(--info);
}
.settings-note.warn {
  background: var(--warn-soft);
  border-color: var(--warn-soft);
}
.settings-note.warn svg {
  color: var(--warn);
}

/* ── Pending wallet request banner ── */
.pending-request-banner {
  align-items: flex-start;
}
.pending-request-content h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 4px;
}
.pending-request-content > p {
  font-size: 13px;
  color: var(--ink-secondary);
  margin: 0 0 12px;
}
.pending-request-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}
.pending-request-details .detail-row {
  display: flex;
  gap: 8px;
  font-size: 13px;
}
.pending-request-details .detail-label {
  color: var(--ink-muted);
  min-width: 90px;
}
.pending-request-details .detail-value {
  color: var(--ink);
}
.pending-request-details .detail-value.mono {
  font-family: var(--font-mono);
  word-break: break-all;
}

/* ─── Password toggle ─────────────────────────────────────────────────────── */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.password-input-wrapper input {
  flex: 1 1;
  padding-right: 44px;
}
.password-toggle {
  position: absolute;
  right: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: var(--ink-muted);
  cursor: pointer;
}
.password-toggle:hover {
  color: var(--ink);
}

/* ─── Footer actions ──────────────────────────────────────────────────────── */
.settings-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* ─── Loading ─────────────────────────────────────────────────────────────── */
.settings-page .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 64px 0;
  color: var(--ink-muted);
}

/* ─── Tablet (577–991px) ──────────────────────────────────────────────────── */
@media (max-width: 991px) {
  .settings-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .settings-rail__slider{
    background: unset;
  }
  .settings-rail-group + .settings-rail-group {
    margin-top: 0px;
  }
  /* Tab rail becomes a horizontal scroll strip on top */
  .settings-rail {
    position: static;
    flex-direction: row;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    gap: 4px;
    padding-bottom: 6px;
    border-bottom: unset;
  }
  .settings-rail::-webkit-scrollbar {
    display: none;
  }
  .settings-rail-item {
    width: auto;
    min-height: 44px;
    flex-shrink: 0;
    white-space: nowrap;
  }
}

/* ─── Mobile (<=576px) ────────────────────────────────────────────────────── */
@media (max-width: 576px) {
  .settings-page {
    overflow-x: hidden;
  }

  /* iOS-style drill-in list (replaces the rail on mobile) */
  .settings-mobile-list {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }
  .settings-mobile-section {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--line);
    border-radius: var(--r-md);
    overflow: hidden;
    background: var(--bg-surface);
  }
  .settings-mobile-section-heading {
    padding: 10px 16px 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--ink-muted);
  }
  .settings-mobile-row {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 52px;
    padding: 12px 16px;
    border: none;
    border-top: 1px solid var(--line);
    background: transparent;
    color: var(--ink);
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    font-family: var(--iv-sans);
  }
  .settings-mobile-row:active {
    background: var(--bg-inset);
  }
  .settings-mobile-row svg {
    flex-shrink: 0;
    color: var(--ink-muted);
  }
  .settings-mobile-row-label {
    flex: 1 1;
    min-width: 0;
  }
  .settings-mobile-row-chevron {
    color: var(--ink-muted);
  }

  /* Back control at the top of the detail view */
  .settings-mobile-back {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-height: 44px;
    margin-bottom: 6px;
    padding: 6px 8px 6px 0;
    border: none;
    background: transparent;
    color: var(--accent-ink, var(--ink));
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    font-family: var(--iv-sans);
  }
  .settings-mobile-back svg {
    flex-shrink: 0;
  }

  /* Single-column form grids on mobile */
  .rd-grid-2col {
    grid-template-columns: 1fr;
  }

  /* Inputs: full width, prevent iOS zoom, comfortable tap target */
  .settings-form .rd-input,
  .settings-form .rd-select,
  .settings-form .rd-textarea {
    width: 100%;
    min-height: 44px;
    box-sizing: border-box;
    font-size: 16px;
  }

  /* KYB row stacks */
  .settings-kyb {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  /* Footer: stack, full-width primary */
  .settings-footer {
    flex-direction: column-reverse;
    gap: 8px;
  }
  .settings-footer .rd-btn,
  .settings-form-actions .rd-btn {
    width: 100%;
    min-height: 44px;
    justify-content: center;
  }

  /* Touch targets for copy / toggle buttons */
  .settings-section .icon-btn {
    width: 44px;
    height: 44px;
  }
  .password-toggle {
    width: 44px;
    height: 44px;
  }

  /* Pending request details wrap */
  .pending-request-details .detail-row {
    flex-direction: column;
    gap: 2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Settings.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,gFAAgF;AAChF;EACE,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAS;AACX;AACA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;0EAC0E;AAC1E;;EAEE,wBAAwB;EACxB,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;SACS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;;2CAE2C;AAC3C;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;6DAC6D;AAC7D;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA,sDAAsD;EACtD;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,kBAAkB;EACpB;;EAEA,0DAA0D;EAC1D;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,SAAO;IACP,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;EACA;IACE,cAAc;EAChB;;EAEA,uCAAuC;EACvC;IACE,0BAA0B;EAC5B;;EAEA,iEAAiE;EACjE;;;IAGE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA,sCAAsC;EACtC;IACE,8BAA8B;IAC9B,QAAQ;EACV;EACA;;IAEE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,4CAA4C;EAC5C;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,iCAAiC;EACjC;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":["/*\n * Settings.css — Page-scoped styles for src/pages/Settings.jsx (light redesign).\n * Consumes redesign.css tokens/primitives; never redefines them.\n * Breakpoints: mobile <=576px | tablet 577-991px | laptop 992-1280px | desktop >=1281px\n */\n\n/* ─── Page shell ──────────────────────────────────────────────────────────── */\n.settings-page {\n  max-width: 100%;\n}\n\n/* ─── Message banner (replaces legacy .message-banner styling) ────────────── */\n.rd-message-banner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-radius: var(--r-md);\n  border: 1px solid var(--line);\n  background: var(--bg-surface);\n  color: var(--ink);\n  font-size: 14px;\n  box-shadow: var(--sh-sm);\n  margin-bottom: 20px;\n}\n.rd-message-banner.success {\n  background: var(--ok-soft);\n  border-color: var(--ok-soft);\n  color: var(--ok);\n}\n.rd-message-banner.error {\n  background: var(--err-soft);\n  border-color: var(--err-soft);\n  color: var(--err);\n}\n.rd-message-banner.info {\n  background: var(--info-soft);\n  border-color: var(--info-soft);\n  color: var(--info);\n}\n.rd-message-banner span {\n  flex: 1;\n  min-width: 0;\n}\n.rd-message-close {\n  background: transparent;\n  border: none;\n  color: inherit;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.7;\n  padding: 0 4px;\n}\n.rd-message-close:hover {\n  opacity: 1;\n}\n\n/* ─── Two-column layout: left rail + right content ────────────────────────── */\n.settings-layout {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n  gap: 28px;\n  align-items: start;\n}\n\n/* ── Left vertical tab rail ── */\n.settings-rail {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  position: sticky;\n  top: 16px;\n}\n/* Category grouping — a small uppercase heading above each cluster of items. */\n.settings-rail-group {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.settings-rail-group + .settings-rail-group {\n  margin-top: 14px;\n}\n.settings-rail-heading {\n  padding: 0 12px 4px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ink-muted);\n}\n.settings-rail-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 12px;\n  border: none;\n  border-radius: var(--r-sm);\n  background: transparent;\n  color: var(--ink-secondary);\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s;\n  font-family: var(--iv-sans);\n}\n.settings-rail-item svg {\n  flex-shrink: 0;\n  color: var(--ink-muted);\n}\n.settings-rail-item:hover {\n  background: var(--bg-inset);\n  color: var(--ink);\n}\n.settings-rail-item.active {\n  background: var(--bg-inset);\n  color: var(--ink);\n  font-weight: 600;\n}\n.settings-rail-item.active svg {\n  color: var(--ink);\n}\n\n/* ── Right content column ── */\n.settings-content {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.settings-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ─── Card head (icon tile + title/sub) ───────────────────────────────────── */\n.settings-card-head {\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.rd-card-sub {\n  font-size: 13px;\n  color: var(--ink-secondary);\n  margin-top: 2px;\n}\n\n/* ─── Form layout inside cards ────────────────────────────────────────────── */\n.settings-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.rd-grid-2col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n}\n.settings-form-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Error-state field (pairs with .rd-input / .rd-textarea): red border and a\n   faint red fill, as on the invoice form's \"Customer name is required\". */\n.rd-input-error,\n.rd-input-error:focus {\n  border-color: var(--err);\n  background: rgba(220, 38, 38, 0.035);\n  box-shadow: 0 0 0 3px var(--err-soft);\n}\n\n/* The message just below the field, in red. Spacing comes from .rd-field's\n   gap. */\n.rd-error {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n}\n\n.input-disabled {\n  background: var(--bg-inset);\n  color: var(--ink-muted);\n  cursor: not-allowed;\n}\n\n/* ─── Logo upload ─────────────────────────────────────────────────────────── */\n.logo-upload {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.logo-preview {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--r-md);\n  background: var(--accent-soft);\n  color: var(--accent-ink);\n  display: grid;\n  place-items: center;\n  font-weight: 700;\n  font-size: 16px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n.logo-remove {\n  color: var(--err);\n}\n\n/* The hint doubles as the staged-state indicator: while a file is selected but\n   not yet uploaded it has to read as a pending action, not as help text, or the\n   preview looks like a completed upload. */\n.rd-hint.logo-staged {\n  color: var(--warn-ink, #b9760a);\n  font-weight: 600;\n}\n\n/* A dashed ring around the preview, for the same reason — it marks the image as\n   not yet committed without needing a second line of copy. */\n.logo-upload:has(.logo-staged) .logo-preview {\n  outline: 2px dashed var(--warn, #f5a524);\n  outline-offset: 2px;\n}\n\n/* ─── Wallet address row ──────────────────────────────────────────────────── */\n.wallet-input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n.wallet-input-row input {\n  flex: 1;\n  min-width: 0;\n}\n.settings-section .icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: var(--r-sm);\n  border: 1px solid var(--line-strong);\n  background: var(--bg-surface);\n  color: var(--ink-secondary);\n  cursor: pointer;\n  box-shadow: var(--sh-sm);\n}\n.settings-section .icon-btn:hover:not(:disabled) {\n  background: var(--bg-inset);\n}\n.settings-section .icon-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ─── KYB status row ──────────────────────────────────────────────────────── */\n.settings-kyb {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding-top: 18px;\n  border-top: 1px solid var(--line);\n}\n.settings-kyb-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink);\n}\n\n/* ─── Notes (info / warning callouts) ─────────────────────────────────────── */\n.settings-note {\n  display: flex;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: var(--r-md);\n  border: 1px solid var(--line);\n  background: var(--bg-subtle);\n}\n.settings-note svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.settings-note strong {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ink);\n  margin-bottom: 2px;\n}\n.settings-note p {\n  font-size: 13px;\n  color: var(--ink-secondary);\n  margin: 0;\n}\n.settings-note.info {\n  background: var(--info-soft);\n  border-color: var(--info-soft);\n}\n.settings-note.info svg {\n  color: var(--info);\n}\n.settings-note.warn {\n  background: var(--warn-soft);\n  border-color: var(--warn-soft);\n}\n.settings-note.warn svg {\n  color: var(--warn);\n}\n\n/* ── Pending wallet request banner ── */\n.pending-request-banner {\n  align-items: flex-start;\n}\n.pending-request-content h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink);\n  margin: 0 0 4px;\n}\n.pending-request-content > p {\n  font-size: 13px;\n  color: var(--ink-secondary);\n  margin: 0 0 12px;\n}\n.pending-request-details {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n.pending-request-details .detail-row {\n  display: flex;\n  gap: 8px;\n  font-size: 13px;\n}\n.pending-request-details .detail-label {\n  color: var(--ink-muted);\n  min-width: 90px;\n}\n.pending-request-details .detail-value {\n  color: var(--ink);\n}\n.pending-request-details .detail-value.mono {\n  font-family: var(--font-mono);\n  word-break: break-all;\n}\n\n/* ─── Password toggle ─────────────────────────────────────────────────────── */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.password-input-wrapper input {\n  flex: 1;\n  padding-right: 44px;\n}\n.password-toggle {\n  position: absolute;\n  right: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: var(--ink-muted);\n  cursor: pointer;\n}\n.password-toggle:hover {\n  color: var(--ink);\n}\n\n/* ─── Footer actions ──────────────────────────────────────────────────────── */\n.settings-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n/* ─── Loading ─────────────────────────────────────────────────────────────── */\n.settings-page .loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 64px 0;\n  color: var(--ink-muted);\n}\n\n/* ─── Tablet (577–991px) ──────────────────────────────────────────────────── */\n@media (max-width: 991px) {\n  .settings-layout {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .settings-rail__slider{\n    background: unset;\n  }\n  .settings-rail-group + .settings-rail-group {\n    margin-top: 0px;\n  }\n  /* Tab rail becomes a horizontal scroll strip on top */\n  .settings-rail {\n    position: static;\n    flex-direction: row;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    gap: 4px;\n    padding-bottom: 6px;\n    border-bottom: unset;\n  }\n  .settings-rail::-webkit-scrollbar {\n    display: none;\n  }\n  .settings-rail-item {\n    width: auto;\n    min-height: 44px;\n    flex-shrink: 0;\n    white-space: nowrap;\n  }\n}\n\n/* ─── Mobile (<=576px) ────────────────────────────────────────────────────── */\n@media (max-width: 576px) {\n  .settings-page {\n    overflow-x: hidden;\n  }\n\n  /* iOS-style drill-in list (replaces the rail on mobile) */\n  .settings-mobile-list {\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n  }\n  .settings-mobile-section {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--line);\n    border-radius: var(--r-md);\n    overflow: hidden;\n    background: var(--bg-surface);\n  }\n  .settings-mobile-section-heading {\n    padding: 10px 16px 6px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--ink-muted);\n  }\n  .settings-mobile-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    min-height: 52px;\n    padding: 12px 16px;\n    border: none;\n    border-top: 1px solid var(--line);\n    background: transparent;\n    color: var(--ink);\n    font-size: 16px;\n    font-weight: 500;\n    text-align: left;\n    cursor: pointer;\n    font-family: var(--iv-sans);\n  }\n  .settings-mobile-row:active {\n    background: var(--bg-inset);\n  }\n  .settings-mobile-row svg {\n    flex-shrink: 0;\n    color: var(--ink-muted);\n  }\n  .settings-mobile-row-label {\n    flex: 1;\n    min-width: 0;\n  }\n  .settings-mobile-row-chevron {\n    color: var(--ink-muted);\n  }\n\n  /* Back control at the top of the detail view */\n  .settings-mobile-back {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    min-height: 44px;\n    margin-bottom: 6px;\n    padding: 6px 8px 6px 0;\n    border: none;\n    background: transparent;\n    color: var(--accent-ink, var(--ink));\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    font-family: var(--iv-sans);\n  }\n  .settings-mobile-back svg {\n    flex-shrink: 0;\n  }\n\n  /* Single-column form grids on mobile */\n  .rd-grid-2col {\n    grid-template-columns: 1fr;\n  }\n\n  /* Inputs: full width, prevent iOS zoom, comfortable tap target */\n  .settings-form .rd-input,\n  .settings-form .rd-select,\n  .settings-form .rd-textarea {\n    width: 100%;\n    min-height: 44px;\n    box-sizing: border-box;\n    font-size: 16px;\n  }\n\n  /* KYB row stacks */\n  .settings-kyb {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  /* Footer: stack, full-width primary */\n  .settings-footer {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n  .settings-footer .rd-btn,\n  .settings-form-actions .rd-btn {\n    width: 100%;\n    min-height: 44px;\n    justify-content: center;\n  }\n\n  /* Touch targets for copy / toggle buttons */\n  .settings-section .icon-btn {\n    width: 44px;\n    height: 44px;\n  }\n  .password-toggle {\n    width: 44px;\n    height: 44px;\n  }\n\n  /* Pending request details wrap */\n  .pending-request-details .detail-row {\n    flex-direction: column;\n    gap: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
